<template>
  <div
    v-if="src"
    class="image-lightbox"
    role="dialog"
    aria-modal="true"
    @click.self="close"
  >
    <button type="button" class="image-lightbox-close" :aria-label="closeLabel" @click="close">×</button>
    <img :src="src" alt="Preview" class="image-lightbox-img" @click.stop />
  </div>
</template>

<script>
export default {
  name: 'ImageLightbox',
  props: {
    src: { type: String, default: '' },
    closeLabel: { type: String, default: 'Close' }
  },
  methods: {
    close: function() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.image-lightbox {
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: rgba(0, 0, 0, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px 24px;
  box-sizing: border-box;
}
.image-lightbox-img {
  max-width: 100%;
  max-height: calc(100vh - 96px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: var(--radius-md, 8px);
  cursor: default;
}
.image-lightbox-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.image-lightbox-close:hover {
  background: rgba(255, 255, 255, 0.22);
}
</style>
